function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var purchaseService = require('./service.js');
var overridePrices = require('./override.js');
var ebtService = require('../../module/PTFs/ebt.js');
var feeService = require('../../module/PTFs/fee.js');
var feebusterService = require('../../module/PTFs/feebuster.js');
var freeproductsService = require('../../module/PTFs/freeproducts.js');
var manualdiscountService = require('../../module/PTFs/manualdiscount.js');
var modifierService = require('../../module/PTFs/modifier.js');
var priceoverrideService = require('../../module/PTFs/priceoverride.js');
var promoService = require('../../module/PTFs/promo.js');
var taxService = require('../../module/PTFs/tax.js');
var calculatePriceTaxFeeAdjusters = require('./calculate.js');
var restorePurchaseService = function restorePurchaseService(_ref) {
  var _points_config$exclud, _basket$overrides;
  var basket = _ref.basket,
    fee_buster_config = _ref.fee_buster_config,
    points_config = _ref.points_config,
    price_increase = _ref.price_increase;
  if (basket.basketid) {
    purchaseService.basket = basket.basketid;
  }
  if (fee_buster_config) {
    purchaseService.feeBusterConfig = fee_buster_config;
  }

  // Handle points config
  if (points_config !== null && points_config !== void 0 && points_config.enabled && points_config !== null && points_config !== void 0 && (_points_config$exclud = points_config.excludedDepts) !== null && _points_config$exclud !== void 0 && _points_config$exclud.length) {
    purchaseService.pointsExcludedDepts = points_config.excludedDepts;
  }

  // Handle price increase config
  purchaseService.priceIncrease = price_increase.enabled;

  // Reset priceTaxFeeAdjusters
  purchaseService.priceTaxFeeAdjusters = [];
  purchaseService.purchases.length = 0;

  // Prepare purchases
  basket.purchases.forEach(purchaseService.addItem);
  var t = basket;
  var priceTaxFeeAdjustersTemp = t.priceTaxFeeAdjusters;

  /*
   * ["fee", "promo", "tax"]
   * removed before zipped to cloud so won't find here
   */
  var ptfs = {
    discountontotal: promoService,
    ebt: ebtService,
    feebuster: feebusterService,
    freeproducts: freeproductsService,
    manualdiscount: manualdiscountService,
    itemModifierPTF: modifierService,
    priceoverride: priceoverrideService
  };
  t.priceTaxFeeAdjusters = [];
  var _iterator = _createForOfIteratorHelper(priceTaxFeeAdjustersTemp),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var ptfData = _step.value;
      var service = ptfs[ptfData.name];
      var ptf = new service.priceTaxFeeAdjuster(ptfData.supplementalData, false);
      for (var prop in ptfData) {
        ptf[prop] = ptfData[prop];
      }
      t.priceTaxFeeAdjusters.push(ptf);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  t.priceTaxFeeAdjusters.push(new taxService.priceTaxFeeAdjuster());
  t.priceTaxFeeAdjusters.push(new feeService.priceTaxFeeAdjuster());

  // set the IDs of the purchase PTF-Adjustments match those of the purchase-service PTF-Adjusters
  t.priceTaxFeeAdjusters.filter(function (a) {
    return ['promo', 'tax', 'fee'].includes(a.name);
  }).forEach(function (PTF) {
    t.purchases.forEach(function (p) {
      if (p.priceTaxFeeAdjustments) {
        p.priceTaxFeeAdjustments.forEach(function (ptf) {
          // match pre-tax and post-tax promos using priority
          if (PTF.name === ptf.name && PTF.priority === ptf.priority) {
            ptf.id = PTF.id;
          }
        });
      }
    });
  });
  purchaseService.priceTaxFeeAdjusters = t.priceTaxFeeAdjusters;
  Object.assign(purchaseService.reg, t.reg);
  if (basket.brnumber) {
    purchaseService.reg.brnumber = basket.brnumber;
  }
  if ((_basket$overrides = basket.overrides) !== null && _basket$overrides !== void 0 && _basket$overrides.length) {
    purchaseService = overridePrices(overrides, purchaseService);
  }

  // Populate the promo net impact object
  purchaseService.refreshIntPromoPricelist({
    field: 'intPromoPriceTotals',
    purchaselist: purchaseService.purchases
  });
  purchaseService.refreshIntPromoPricelist({
    field: 'intPromoPriceTotalsCash',
    purchaselist: purchaseService.getCashPricePurchases()
  });
  purchaseService.tipsInformations = {
    tips: basket.tipsInformations.tips,
    tipstype: basket.tipsInformations.tipstype,
    tipsamt: basket.tipsInformations.tipsamt
  };

  // Populate the PTFs
  return calculatePriceTaxFeeAdjusters(purchaseService);
};
module.exports = restorePurchaseService;